'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ROTATE_X: ['rotateX(-180deg)', 'rotateX(0deg)'],
  ROTATE_Y: ['rotateY(-180deg)', 'rotateY(0deg)'],
  SCALE: ['scale(1.8, 1.8)', 'scale(1, 1)']
};


// WEBPACK FOOTER //
// ../~/react-notification-badge/lib/components/Effect.js